import ItemTypeBaseController from '../common/item_type.base.controller';

class itemTypeAllController extends ItemTypeBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, ItemTypeService, $translate, $stateParams, $location,) {
    super(Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams)

    this.User = User;
    this.$state = $state;
    this.$location = $location;
    this.hasAcl = {};
    this.model = {
      ItemTypeObj: {
        totalRecords: 0,
        categoryList: [],
        loading: false
      },
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 10,
        maxPages: 10
      },
      searchText: '',
    }
  }

  $onInit() {
    this.loadData();
  }

  loadData() {
    this.model.pagination.page = 1;
    this.loadAllItemType();
  }

  searchObj() {
    const obj = {
      queryJSON: {
        rules: [{
          group: {
            rules: [{
              field: 'label',
              condition: 'like',
              data: '%' + this.model.searchText + '%'
            }],
            operator: 'OR'
          }
        }],
        operator: 'AND'
      }
    }
    return obj.queryJSON.rules.length ? obj : null;
  }


  loadAllItemType() {
    this.model.ItemTypeObj.loading = true;
    this.Service.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit)
      .then((data) => {
        this.model.ItemTypeObj.categoryList = data.results;
        this.model.ItemTypeObj.totalRecords = data.total;
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
      .finally(() => {
        this.model.ItemTypeObj.loading = false;
      })
  }


  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.model.pagination.page)
    this.$stateParams.page = this.model.pagination.page;
    this.$location.path(newUrl);
    this.loadAllItemType();
  }

  search() {
    this.pageChange();
  }


  editItemType(itemsType) {
    this.$state.go('items-type.edit', ({
      id: itemsType.id,
    }))
  }

}

export default itemTypeAllController;


// WEBPACK FOOTER //
// ./client/app/components/item_type/all/item_type.all.controller.js